const gamification = [
	{
		path: '/gamification/missions',
		name: 'gamification-missions-list',
		component: () => import(/* webpackChunkName: "GamificationMissions" */ '@/views/gamification/missions/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,gamification',
		},
	},
	{
		path: '/gamification/achievements',
		name: 'gamification-achievements-list',
		component: () => import(/* webpackChunkName: "GamificationAchievements" */ '@/views/gamification/achievements/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,gamification',
		},
	},
	{
		path: '/gamification/reward-rules',
		name: 'gamification-reward-rules-list',
		component: () => import(/* webpackChunkName: "GamificationRewardRules" */ '@/views/gamification/rewardRules/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,gamification',
		},
	},
	{
		path: '/gamification/mission-categories',
		name: 'gamification-mission-categories-list',
		component: () => import(/* webpackChunkName: "GamificationMissionCategories" */ '@/views/gamification/missionCategories/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,gamification',
		},
	},
	{
		path: '/gamification/achievement-categories',
		name: 'gamification-achievement-categories-list',
		component: () => import(/* webpackChunkName: "GamificationAchievementCategories" */ '@/views/gamification/achievementCategories/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,gamification',
		},
	},
	{
		path: '/gamification/level-definitions',
		name: 'gamification-level-definitions-list',
		component: () => import(/* webpackChunkName: "GamificationLevelDefinitions" */ '@/views/gamification/levelDefinitions/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,gamification',
		},
	},
	{
		path: '/gamification/reward-items',
		name: 'gamification-reward-items-list',
		component: () => import(/* webpackChunkName: "GamificationRewardItems" */ '@/views/gamification/rewardItems/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,gamification',
		},
	},
	{
		path: '/gamification/redemptions',
		name: 'gamification-redemptions-list',
		component: () => import(/* webpackChunkName: "GamificationRedemptions" */ '@/views/gamification/redemptions/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,gamification',
		},
	},
]

export default gamification
